import AbstractForecastColumn from "./AbstractForecastColumn.js";

/**
 * This column is used to handle the data predicted on the upcoming periods in
 * the forecasting table. It must always be visible even if there is no data.
 *
 * @param {MonthPeriod} start - The forecast period to which the
 *   column is associated
 */
export default class PredictedForecastColumn extends AbstractForecastColumn {
	accept(visitor) {
		return visitor.visitPredictedForecastColumn(this);
	}

	isPredictedForecastColumn() {
		return true;
	}
}
